import { Link } from "react-router-dom";
import Seo from "@/components/common/Seo";
import Breadcrumb from "@/components/feature/Breadcrumb";

const values = [
  { icon: "ri-focus-3-line", title: "专注好看韩漫", desc: "只聚合口碑与人气俱佳的好看韩漫，宁缺毋滥，帮你少走弯路。" },
  { icon: "ri-honor-of-kings-line", title: "书源真实可看", desc: "推荐的每个韩漫在线阅读站都经过人工巡检，标注稳定度，真实可打开。" },
  { icon: "ri-eye-line", title: "尊重原创", desc: "坚持收录公开书源并呼吁支持正版，让创作者能持续产出好作品。" },
];

export default function AboutPage() {
  return (
    <>
      <Seo
        title="关于我们 - 韩漫大全在线阅读站"
        description="韩漫大全是一个聚合免费书源的韩漫在线阅读站，专注解决好看的韩漫大全哪个网站有，推荐稳定收藏站点，让好看韩漫随时看、追更不迷路。"
        keywords="韩漫大全,关于我们,韩漫在线阅读站,韩漫书源推荐"
        canonical="https://hkmans1.github.io/about"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "AboutPage",
          name: "关于韩漫大全",
          description: "聚合免费书源的韩漫在线阅读站，推荐稳定收藏站点。",
        }}
      />

      <div className="mx-auto w-full max-w-4xl px-4 py-8 md:py-12">
        <Breadcrumb items={[{ label: "首页", to: "/" }, { label: "关于我们" }]} />

        <div className="mt-5">
          <h1 className="heading-font text-2xl font-bold text-foreground-950 md:text-3xl">关于韩漫大全</h1>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            韩漫大全是一个以聚合免费韩漫书源为核心的在线阅读导航平台。很多读者在找好漫画时总会陷入同一个困扰——好看的韩漫大全哪个网站有？网站太多、广告太杂、链接时好时坏，追更更是容易迷路。
          </p>
          <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
            我们把这些优质书源聚合到一处，按题材分类、按稳定度排序，并清晰标注每个站点的更新速度与下载支持情况。你只要收藏一个韩漫大全站点，就能随时打开随时看，热门新番与经典佳作一手掌握。
          </p>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-3">
          {values.map((v) => (
            <div key={v.title} className="rounded-2xl border border-background-200/70 bg-background-100 p-6">
              <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
                <i className={`${v.icon} text-2xl`} />
              </span>
              <h2 className="heading-font mt-4 text-lg font-bold text-foreground-950">{v.title}</h2>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{v.desc}</p>
            </div>
          ))}
        </div>

        <section className="mt-10 rounded-2xl bg-secondary-100 p-6 md:p-8">
          <h2 className="heading-font text-xl font-bold text-foreground-950">我们的定位与理念</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            我们把自己定位成读者的“韩漫书源地图”——不做内容生产，专注帮你把分散在网络各处的免费韩漫在线阅读站整理成一份清晰、稳定、好上手的收藏清单。内容原则很简单：推荐真实可访问的站点、标注客观数据、不夸大不吹嘘。
          </p>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            追更提醒、离线下载、多书源切换……我们希望这些细节能让你的韩漫阅读体验更省心。网站会持续更新书源，把突然失效的链接及时替换，把新出现的好站点第一时间收录。
          </p>
        </section>

        <section className="mt-10">
          <h2 className="heading-font text-xl font-bold text-foreground-950">用户怎么说</h2>
          <div className="mt-5 grid gap-4 md:grid-cols-2">
            {[
              { name: "追漫的小鹿", text: "终于不用再问好看的韩漫大全哪个网站有了，这里聚合的书源一个比一个顺，追更提醒很贴心。" },
              { name: "阿澈", text: "书源的稳定性评分很实用，遇到打不开的站点我直接换高分书源，体验好太多。" },
              { name: "Momo", text: "分类特别细，按题材筛选很快就能找到喜欢的韩漫，首页推荐的质量也高。" },
            ].map((u) => (
              <figure key={u.name} className="rounded-2xl bg-background-100 p-5">
                <p className="text-sm leading-relaxed text-foreground-700">“{u.text}”</p>
                <figcaption className="mt-3 flex items-center gap-2 text-sm font-bold text-foreground-950">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className="ri-user-smile-line" />
                  </span>
                  {u.name}
                </figcaption>
              </figure>
            ))}
          </div>
        </section>

        <section className="mt-10 rounded-2xl bg-background-100 p-6 text-center md:p-8">
          <h2 className="heading-font text-xl font-bold text-foreground-950">需要帮助或建议？</h2>
          <p className="mt-2 text-sm text-foreground-600">欢迎通过常见问题或联系邮箱与我们交流，帮助我们做得更好。</p>
          <div className="mt-5 flex flex-col justify-center gap-3 sm:flex-row">
            <Link to="/faq" className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-6 py-2.5 text-sm font-bold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600">
              查看常见问题
            </Link>
            <Link to="/shuyuan" className="inline-flex items-center justify-center gap-2 rounded-full bg-accent-500 px-6 py-2.5 text-sm font-bold text-foreground-950 whitespace-nowrap transition-colors hover:bg-accent-600">
              去逛免费书源
            </Link>
          </div>
        </section>
      </div>
    </>
  );
}